import React, { createContext, useContext, useMemo } from 'react'
import { ChangeGroupImageOverlay } from '@fs/zion-group-management'
import { useOverlay } from '@fs/zion-ui'

const GroupManagementGroupContext = createContext()

/**
 * @typedef {object} GroupManagementValue
 * @property {import('@fs/zion-tree-types').GroupSummary} group
 * @property {Function} refetchGroup
 * @property {Function} onLeaveGroup
 * @property {import('@fs/zion-ui').UseOverlayReturnOptions} changeImageOverlay
 */

/**
 *
 * @returns {GroupManagementValue}
 */

export const useGroupManagementGroupContext = () => useContext(GroupManagementGroupContext)

/**
 *
 * @param {GroupManagementValue & {children: import('react').ReactNode}} props
 * @returns {JSX.Element}
 */

export default function GroupManagementGroupProvider({ children, group, refetchGroup, onLeaveGroup }) {
  const changeImageOverlay = useOverlay()
  const value = useMemo(
    () => ({
      group,
      refetchGroup,
      onLeaveGroup,
      changeImageOverlay,
    }),
    [group, refetchGroup, onLeaveGroup, changeImageOverlay]
  )
  return (
    <GroupManagementGroupContext.Provider value={value}>
      {children}
      <ChangeGroupImageOverlay group={group} overlay={changeImageOverlay} onGroupImageChange={refetchGroup} />
    </GroupManagementGroupContext.Provider>
  )
}
